import React, { useState } from "react";
import { RxChevronDown } from "react-icons/rx";
import Dropdown from "../commons/Dropdown";
import { useBot } from "../../context/botContext";
import { MagnifyingGlassIcon, XMarkIcon } from "@heroicons/react/24/outline";
import InputWithIcon from "../commons/InputWithIcon";
import { XCircleIcon } from "@heroicons/react/16/solid";
import { normalizeBotName } from "../../utils";

export const PortfolioFilter = ({
  setSearchText,
  searchText,
  handleSearch,
  selectedExchange,
  setSelectedExchange,
  isHistory,
  selectedStrategy,
  setSelectedStrategy,
}) => {
  const { exchanges, strategyLists } = useBot();
  const [openSearch, setOpenSearch] = useState(false);

  return (
    <div
      className={`flex items-center justify-between gap-4 ${
        openSearch && "max-md:gap-0"
      }`}
    >
      {/* Exchange Dropdown */}

      <div
        className={`flex items-center gap-4 w-full transition-[width] max-md:pr-2 max-md:overflow-x-auto max-md:py-2 no-scrollbar ${
          openSearch &&
          "max-md:w-[0] max-md:opacity-0 max-md:pointer-events-none max-md:pr-0"
        }`}
      >
        <label
          className={`block text-gray-500 mb-1 !text-sm whitespace-nowrap`}
        >
          Filter by
        </label>
        {!!!selectedExchange?.id ? (
          <Dropdown
            id="exchange"
            placeholder="All Exchange"
            label="Filter by"
            className={"flex gap-3 items-center shadow-none !border-none"}
            classNameContainer={"max-w-[200px]  "}
            classNameLabel={"!text-sm whitespace-nowrap hidden"}
            classNameInput={
              "max-md:!w-[150px] !w-full !bg-transparent !ring-1 !ring-[#DDE1E6] !shadow-none !mt-0 whitespace-nowrap"
            }
            classNameDropdown={"w-[200px] right-0"}
            options={[{ id: "", name: "All Exchange" }, ...exchanges]}
            value={selectedExchange}
            onChange={(val) => setSelectedExchange(val)}
            isDialog
          />
        ) : (
          <div
            className="flex items-center bg-[#007A78]/10 text-[#21272A] border border-[#007A78] px-3 py-2 rounded-xl text-sm font-semibold cursor-pointer"
            onClick={() =>
              setSelectedExchange({ id: "", name: "All Exchange" })
            }
          >
            {selectedExchange?.name}{" "}
            <XCircleIcon className="w-[16px] h-[16px] ml-2 text-[#21272A]" />
          </div>
        )}

        {isHistory &&
          (!!!selectedStrategy?.id ? (
            <Dropdown
              id="exchange"
              placeholder="All Bot"
              label="Filter by"
              className={"flex gap-3 items-center shadow-none !border-none"}
              classNameContainer={"max-w-[200px] "}
              classNameLabel={"!text-sm whitespace-nowrap hidden"}
              classNameInput={
                "max-md:!w-[150px] !w-full !bg-transparent !ring-1 !ring-[#DDE1E6] !shadow-none !mt-0 whitespace-nowrap"
              }
              classNameDropdown={"w-[200px] right-0"}
              options={[
                { id: "", name: "All Bot", key: "" },
                ...strategyLists.map((bt) => ({
                  ...bt,
                  key: bt.bot_name,
                  name: normalizeBotName(bt.bot_name),
                })),
              ]}
              value={selectedStrategy}
              onChange={(val) => setSelectedStrategy(val)}
              isDialog
            />
          ) : (
            <div
              className="flex items-center bg-[#007A78]/10 text-[#21272A] border border-[#007A78] px-3 py-2 rounded-xl text-sm font-semibold cursor-pointer"
              onClick={() =>
                setSelectedStrategy({ id: "", name: "All Bot", key: "" })
              }
            >
              {selectedStrategy?.name}{" "}
              <XCircleIcon className="w-[16px] h-[16px] ml-2 text-[#21272A]" />
            </div>
          ))}
      </div>

      {/* Search Input */}

      <InputWithIcon
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        onKeyDown={handleSearch}
        placeholder="Search"
        leftIcon={
          <MagnifyingGlassIcon className="w-[20px] h-[20px] text-[#697077]" />
        }
        className={`!shadow-none md:w-full md:max-w-[350px] ${
          openSearch && "max-md:!w-full md:!max-w-[350px]"
        }`}
        leftIconClassName={`py-[12px] max-md:!p-0 max-md:w-[60px] max-md:h-[45px]`}
        inputClassName={`max-md:max-w-[0] max-md:!p-0 ${
          openSearch && "max-md:!w-full max-md:!max-w-[100%]"
        }`}
        rightIconClassName="!bg-transparent"
        rightIcon={
          openSearch && (
            <XMarkIcon className="w-[20px] h-[20px] text-[#697077]" />
          )
        }
        onClickIcon={() => {
          setOpenSearch(!openSearch);
        }}
      />
    </div>
  );
};
